import React from "react";
import "./header.css";

function Header() {
  return (
    <div className="header">
      <div className="pagetitle">Password Generator</div>
    </div>
  );
}

export default Header;
